import React from "react";
import PropTypes from "prop-types";
import i18next from "i18next";
import { I18nextProvider } from "react-i18next";
import locales from "./locales";

class I18N extends React.PureComponent {
  static defaultProps = {
    initialLanguage: "en-US",
    resources: locales,
  };

  constructor(props) {
    super(props);
    i18next.init({
      fallbackLng: "en-US",
      fallbackNS: ["translation"],
      resources: props.resources,
      parseMissingKeyHandler: (missing) => {
        if (process.env.NODE_ENV === "development") {
          // eslint-disable-next-line no-console
          console.warn("MISSING TRANSLATION:", missing);
        }
        return missing;
      },
    });
  }

  componentDidMount() {
    const { initialLanguage } = this.props;
    i18next.changeLanguage(initialLanguage);
  }

  componentDidUpdate(prevProps) {
    const { locale: newLocale } = this.props;
    const { locale: oldLocale } = prevProps;

    if (oldLocale !== newLocale) {
      i18next.changeLanguage(newLocale);
    }
  }

  render() {
    const { children, initialLanguage } = this.props;
    return (
      <I18nextProvider i18n={i18next} initialLanguage={initialLanguage}>
        {children}
      </I18nextProvider>
    );
  }
}

I18N.propTypes = {
  children: PropTypes.node.isRequired,
  initialLanguage: PropTypes.string,
  resources: PropTypes.objectOf(
    PropTypes.shape({ translation: PropTypes.objectOf(PropTypes.string) })
  ),
};

export default I18N;
